/**
 * @generated SignedSource<<2d8b7b510d99944773368edeb4563271>>
 * @relayHash 6a01e0589ad4f1367c0bba3ba601824c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a01e0589ad4f1367c0bba3ba601824c

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HtmlTag = "HTML";
export type ChangeHtmlDetailsInput = {
  bodyItemId: string;
  clientMutationId?: string | null;
  value: HtmlInput;
};
export type HtmlInput = {
  type: HtmlTag;
  value: string;
};
export type HtmlChangeMutation$variables = {
  input: ChangeHtmlDetailsInput;
};
export type HtmlChangeMutation$data = {
  readonly changeHtmlDetails: {
    readonly bodyItem: {
      readonly id: string;
      readonly info: any;
    };
  } | null;
};
export type HtmlChangeMutation = {
  response: HtmlChangeMutation$data;
  variables: HtmlChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangeHtmlDetailsPayload",
    "kind": "LinkedField",
    "name": "changeHtmlDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BodyItem",
        "kind": "LinkedField",
        "name": "bodyItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "info",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HtmlChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HtmlChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6a01e0589ad4f1367c0bba3ba601824c",
    "metadata": {},
    "name": "HtmlChangeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c5021f55f888284e3708b9f8dc91b60e";

export default node;
